var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("div", { staticClass: "section-card" }, [
              _c(
                "div",
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        name: "authority_to_leave",
                        value: true,
                        "unchecked-value": false,
                      },
                      model: {
                        value: _vm.authorityToLeave,
                        callback: function ($$v) {
                          _vm.authorityToLeave = $$v
                        },
                        expression: "authorityToLeave",
                      },
                    },
                    [_vm._v("\n            Authority to Leave\n          ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [
                _vm._v("\n          " + _vm._s(_vm.description) + "\n        "),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }